module.exports = __webpack_public_path__ + "img/14.271a3071.png";